"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColumnFilter = void 0;
var React = require("react");
var classNames = require("classnames");
var recompose_1 = require("recompose");
var sok_ui_1 = require("@caddigital/sok-ui");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
require("./styles.scss");
var DatePicker_1 = require("components/DatePicker");
var dropdownOnChange_1 = require("utils/helpers/dropdownOnChange");
var Icon_1 = require("components/Icon");
var checboxOptions = [
    {
        value: true,
        name: 'global/yes'
    },
    {
        value: false,
        name: 'global/no'
    }
];
var getInput = function (props) {
    if (props.meta.type === 'text' || props.meta.type === 'textarea') {
        return (React.createElement(sok_ui_1.TextInput, { value: (props.value !== null ? props.value.value : ''), placeholder: (0, translation_1.getLocalization)('columnFilter/search'), className: "white", autoFocus: true, onFocus: function (e) {
                var val = e.target.value;
                e.target.value = '';
                e.target.value = val;
            }, onChange: function (e) {
                return props.setValue({
                    type: props.meta.type,
                    value: e.target.value.toString()
                });
            }, icon: React.createElement(Icon_1.Icon, { className: 'fa-search' }) }));
    }
    else if (props.meta.type === 'day' || props.meta.type === 'datetime') {
        return (React.createElement(DatePicker_1.DatePicker, { placeholder: (0, translation_1.getLocalization)('columnFilter/search'), parent: props.reference, closeOnSelect: true, dateFormat: 'L', selected: props.value && props.value.value, onChange: function (change) {
                if (change) {
                    props.setValue({
                        type: props.meta.type,
                        value: change
                    });
                }
            } }));
    }
    else if (props.meta.type === 'select' ||
        props.meta.type === 'dependant-select') {
        return (React.createElement(sok_ui_1.Dropdown2, { style: { width: '100%' }, alignment: 'center', isOpen: props.dropdownIsOpen, onChange: function (value) {
                props.toggleDropdown(value);
            } },
            React.createElement("div", { className: 'dropdown-input' },
                React.createElement(sok_ui_1.TextInput, { value: props.value
                        ? props.value.value.name
                        : (0, translation_1.getLocalization)('userfront/project/files/targetYourSearch/AdvancedSearchDropdownContainer/moreSearchTools/label/type/placeHolder/any'), editable: false, placeholder: (0, translation_1.getLocalization)('userfront/project/files/targetYourSearch/AdvancedSearchDropdownContainer/moreSearchTools/label/type/placeHolder/any'), iconRight: React.createElement(Icon_1.Icon, { className: 'fa-caret-down' }) })),
            React.createElement(sok_ui_1.Dropdown2Menu, { className: 'narrow sok-click-wall sok-dropdown2-menu', style: { zIndex: 10001 } }, props.meta.options &&
                [
                    {
                        value: null,
                        name: (0, translation_1.getLocalization)('userfront/project/files/targetYourSearch/AdvancedSearchDropdownContainer/moreSearchTools/label/type/placeHolder/any')
                    }
                ]
                    .concat(props.meta.options)
                    .map(function (o, index) { return (React.createElement(sok_ui_1.Dropdown2MenuItem, { key: index, onClick: function (e) {
                        e.preventDefault();
                        e.stopPropagation();
                        if (o === null) {
                            props.setValue(null);
                        }
                        else {
                            props.setValue({ type: 'select', value: o });
                        }
                        props.toggleDropdown(false);
                    } },
                    React.createElement("div", { className: props.value && props.value === o ? 'active' : '' },
                        React.createElement("label", null, o.name)))); }))));
    }
    else if (props.meta.type === 'checkbox') {
        return (React.createElement(sok_ui_1.Dropdown2, { style: { width: '100%' }, alignment: 'center', isOpen: props.dropdownIsOpen, onChange: function (value) {
                props.toggleDropdown(value);
            } },
            React.createElement("div", { className: 'dropdown-input' },
                React.createElement(sok_ui_1.TextInput, { value: (0, translation_1.getLocalization)(props.value
                        ? (checboxOptions.find(function (x) { return x.value === props.value.value; }) || {}).name
                        : 'global/pleaseSelect'), editable: false, placeholder: (0, translation_1.getLocalization)('global/pleaseSelect'), iconRight: React.createElement(Icon_1.Icon, { className: 'fa-caret-down' }) })),
            React.createElement(sok_ui_1.Dropdown2Menu, { className: 'narrow sok-click-wall sok-dropdown2-menu', style: { zIndex: 10001 } }, checboxOptions.map(function (o, index) { return (React.createElement(sok_ui_1.Dropdown2MenuItem, { key: index, onClick: function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    if (o === null) {
                        props.setValue(null);
                    }
                    else {
                        props.setValue({ type: 'checkbox', value: o.value });
                    }
                    props.toggleDropdown(false);
                } },
                React.createElement("div", { className: props.value && props.value === o ? 'active' : '' },
                    React.createElement("label", null, (0, translation_1.getLocalization)(o.name))))); }))));
    }
};
var enhance = (0, recompose_1.compose)((0, recompose_1.withState)('isOpen', 'setIsOpen', false), (0, recompose_1.withState)('value', 'setValue', null), (0, recompose_1.withState)('reference', 'setReference', undefined), (0, recompose_1.withState)('dropdownIsOpen', 'toggleDropdown', false), (0, recompose_1.lifecycle)({
    componentWillReceiveProps: function (nextProps) {
        if (nextProps.isOpen !== this.props.isOpen) {
            if (nextProps.isOpen === false) {
                nextProps.setValue(null);
            }
            else {
                nextProps.setValue(nextProps.textInputValue);
            }
        }
    }
}), recompose_1.pure);
exports.ColumnFilter = enhance(function (props) { return (React.createElement(sok_ui_1.Dropdown2, { className: classNames('column-filter-component', props.className), isOpen: props.isOpen, onChange: (0, dropdownOnChange_1.dropdownOnChange)(props.isOpen, props.setIsOpen) },
    React.createElement(Icon_1.Icon, { className: classNames('fa-filter', props.className) }),
    React.createElement(sok_ui_1.Dropdown2Menu, { className: 'sok-click-wall filter-dropdown' },
        React.createElement("div", { ref: props.setReference, className: "column-filter-component-menu" }, props.isOpen && (React.createElement("form", { onSubmit: function (e) {
                e.preventDefault();
                if (props.meta.id) {
                    props.setColumnFilterString(props.meta.id.toString(), props.value);
                }
                props.setIsOpen(false);
                props.setValue(null);
            } },
            React.createElement(sok_ui_1.ClickWall, null,
                React.createElement("div", { className: "inputs" }, getInput(props))),
            React.createElement("div", { className: "buttons" },
                React.createElement(sok_ui_1.Button, { color: 'base-blue', text: (0, translation_1.getLocalization)('userfront/filelist/clearFilter'), disabled: !props.value && !props.textInputValue, onClick: function () {
                        props.setIsOpen(false);
                        props.setValue(null);
                        props.clearColumnFilter(props.columnIdentifier);
                    } }),
                React.createElement(sok_ui_1.Button, { color: 'base-green', text: 'OK', type: 'submit' })))))))); });
